/**
 * @generated SignedSource<<48fb3dc2dc63d6271c14b4c05a559934>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbRespSearchResultContainer_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedItemTrackingProvider_viewer" | "SharedItemTile_viewer">;
  readonly " $fragmentType": "SbRespSearchResultContainer_viewer";
};
export type SbRespSearchResultContainer_viewer$key = {
  readonly " $data"?: SbRespSearchResultContainer_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbRespSearchResultContainer_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespSearchResultContainer_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedItemTile_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedItemTrackingProvider_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "f09f076dc59a0359f06ba3bf3366ccf1";

export default node;
